export default __webpack_public_path__ + "static/hall.uebersicht-e38e05ebfda86555461864d94799bc4d.jpg";